<template>
  <div>
    <user :user="user" v-loading="loadingUser" />
    <content-counters
      v-loading="loadingContentCounters"
      :contentCounters="contentCounters"
    />
    <recent-used-codes
      v-loading="loadingRecentUsedCodes"
      :recentUsedCodes="recentUsedCodes"
    />
  </div>
</template>
<script>
import { Dashboard } from '@/api/'
import ContentCounters from './ContentCounters'
import RecentUsedCodes from './RecentUsedCodes'
import User from './User'

export default {
  data() {
    return {
      contentCounters: {},
      user: {},
      recentUsedCodes: [],
      loadingContentCounters: false,
      loadingRecentUsedCodes: false,
      loadingUser: false
    }
  },
  components: {
    ContentCounters,
    RecentUsedCodes,
    User
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loadingContentCounters = true
      Dashboard.getContentCounters()
        .then(res => {
          this.contentCounters = res.data
        })
        .finally(() => {
          this.loadingContentCounters = false
        })

      this.loadingRecentUsedCodes = true
      Dashboard.getRecentUsedCodes()
        .then(res => {
          this.recentUsedCodes = res.data
        })
        .finally(() => {
          this.loadingRecentUsedCodes = false
        })

      this.loadingUser = true
      Dashboard.getUser()
        .then(res => {
          this.user = res.data
        })
        .finally(() => {
          this.loadingUser = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.welcome-text {
  font-size: 36px;
}
</style>
